import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateServiceRequest, IService } from '../models/service';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  constructor(
    private http: HttpClient,
  ){}

  searchServices(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IService[]>>(
      `${environment.baseUrl}/v1/Service/searchServices`,
      request
    )
  }

  getService(id: string){
    return this.http.get<string>(
      `${environment.baseUrl}/v1/Service/getService/${id}`
    )
  }

  createService(request: ICreateServiceRequest){
    return this.http.post<string>(
      `${environment.baseUrl}/v1/Service/createService`,
      request
    )
  }

  updateService(request: IService){
    return this.http.put<string>(
      `${environment.baseUrl}/v1/Service/updateService/${request.id}`,
      request
    )
  }

  deleteService(id: string){
    return this.http.delete<string>(
      `${environment.baseUrl}/v1/Service/deleteService/${id}`
    )
  }
}
